
<full-header-slider class="block relative w-full lg:mt-[-86px]">
  <div class="container lg:pt-[215px] w-full pb-8 flex flex-col items-center text-white">
    <h1 class="text-4xl mt-2 place-self-start" i18n="news general title">General metal industry news</h1>
    <h2 class="text-2xl place-self-start" i18n="news general subtitle">From ferrous to non-ferrous, all the international news from the metallurgical industry</h2>
    <block-horizontal-scroller
      class="mt-4 w-full h-[320px]"
      [pageSize]="6"
      [itemWidth]="400"
      [itemHeight]="320"
      [colGap]="20"
      [itemTpl]="newsScrollerTpl"
      [renderOnTimeOut]="0"
      [itemsQuery]="newsQuery">
    </block-horizontal-scroller>
    <ng-template let-item let-index="index" #newsScrollerTpl>
      <news-block
        class="w-[400px] h-[320px]"
        [newsItem]="item"
        [itemIndex]="index"
        blockSize="large"
        type="portal"
        [imageSizes]="[
        {w: 398, h: 225, resizeMode: 'fill'}
        ]">
      </news-block>
    </ng-template>
  </div>
</full-header-slider>



